<script setup lang="ts">
import type { IStressTest } from '@/types/rc/miners'
import { downloadLinkTarget } from '@/util'

defineProps<{ files: IStressTest['files'] }>()

const isImage = (fileName: string) => {
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(fileName)
}

const getExtensionFromFilename = (fileName: string) => {
  return fileName.split('.').pop()?.toLowerCase() || '?'
}
</script>

<template>
  <div class="grid grid-cols-5 gap-2">
    <template v-for="att in files" :key="att.id">
      <!-- Image thumb -->
      <el-image
        v-if="isImage(att.name)"
        class="cursor-pointer !rounded !w-full aspect-square"
        :title="att.name"
        :src="att.file_url"
        fit="cover"
        @click="downloadLinkTarget(att.file_url, att.name)"
      />

      <!-- Extension txt -->
      <span
        v-else
        class="cursor-pointer rounded w-full aspect-square uppercase bg-fill-tertiary flex items-center justify-center hover:text-text-brand overflow-clip"
        :title="att.name"
        @click="downloadLinkTarget(att.file_url, att.name)"
      >
        {{ getExtensionFromFilename(att.name) }}
      </span>
    </template>
    <Icon icon="mdi:download" class="invisible group-hover:visible" />
  </div>
</template>
